<template>
  <v-container fluid>
    <v-card
      v-if="!displayConfirmDialog && !displayCompletedDialog && isWordListReady"
      :flat="true"
      class="chain-register-form"
    >
      <Form v-slot="{ invalid, validate }" :initial-values="formInitialValues">
        <v-card :flat="true">
          <v-card-title class="mb-3 text-h5 font-weight-bold">
            {{ wordList["lbl_chain_regist"] }}
          </v-card-title>
          <v-card-text>
            <v-card :flat="true" class="pl-5 pt-3">
              <!-- チェーンコード -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_chain_code }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="chain_code"
                    :label="wordList.lbl_chain_code"
                    rules="required|max:8|alpha_dash"
                  >
                    <v-text-field
                      :model-value="field.value ?? chainCreateInput.chain_code"
                      :placeholder="wordList.plc_chain_code"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          chainCreateInput.chain_code = val;
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurChainCd();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- チェーン名 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_chain_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="chain_name"
                    :label="wordList.lbl_chain_name"
                    rules="required|max:20"
                  >
                    <v-text-field
                      :model-value="field.value ?? chainCreateInput.name"
                      :placeholder="wordList.plc_chain_name"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          chainCreateInput.name = val;
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurChainName();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード登録 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_house_card_display }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="house_card_display"
                    :label="wordList.lbl_house_card_display"
                    rules="required"
                  >
                    <v-radio-group
                      v-model="houseCardDisplayRadio"
                      inline
                      mandatory
                      class="mt-0"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          onClickHouseCard(val.id);
                        }
                      "
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in houseCardDisplayRadioItems"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                        color="indigo"
                        density="compact"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード必須 -->
              <v-row v-if="houseCardDisplayRadio['id'] == 1">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_house_card_required }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="house_card_required"
                    :label="wordList.lbl_house_card_required"
                  >
                    <v-radio-group
                      v-model="houseCardRequiredRadio"
                      inline
                      mandatory
                      class="mt-0"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                        }
                      "
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in houseCardRequiredRadioItems"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                        color="indigo"
                        density="compact"
                        :error-messages="errors"
                        :disabled="houseCardDisabled"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード桁数 -->
              <v-row v-if="houseCardDisplayRadio['id'] == 1">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_house_card_digit }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="house_card_digit"
                    :label="wordList.lbl_house_card_digit"
                    rules="max:20"
                  >
                    <v-text-field
                      :model-value="field.value ?? chainCreateInput.house_card_digit"
                      :placeholder="wordList.plc_house_card_digit"
                      density="compact"
                      variant="outlined"
                      :disabled="houseCardDisabled"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          chainCreateInput.house_card_digit = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカードフォーマット -->
              <v-row v-if="houseCardDisplayRadio['id'] == 1">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_house_card_format }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="house_card_format"
                    :label="wordList.lbl_house_card_format"
                    rules="max:20"
                  >
                    <v-text-field
                      :model-value="field.value ?? chainCreateInput.house_card_format"
                      :placeholder="wordList.plc_house_card_format"
                      density="compact"
                      variant="outlined"
                      :disabled="houseCardDisabled"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          chainCreateInput.house_card_format = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- オペレーターのメールアドレス -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_operator_column_email }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="operator_column_email"
                    :label="wordList.lbl_operator_column_email"
                    rules="required"
                  >
                    <v-radio-group
                      v-model="operatorColumnEmailRadio"
                      inline
                      mandatory
                      class="mt-0"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                        }
                      "
                      @blur="field.onBlur"
                    >
                      <v-radio
                        v-for="item in operatorColumnEmailRadioItems"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                        color="indigo"
                        density="compact"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS接続名 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_dss_connection_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="dss_connection_name"
                    :label="wordList.lbl_dss_connection_name"
                    rules="required|max:20"
                  >
                    <v-text-field
                      :model-value="field.value ?? dssConnectionSettingInput.connection_name"
                      :placeholder="wordList.plc_dss_connection_name"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          dssConnectionSettingInput.connection_name = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSSチェーンストアコード -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_dss_chain_store_code }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="dss_chain_store_code"
                    :label="wordList.lbl_dss_chain_store_code"
                    rules="required|max:8|alpha_dash"
                  >
                    <v-text-field
                      :model-value="field.value ?? dssConnectionSettingInput.dss_chain_store_code"
                      :placeholder="wordList.plc_dss_chain_store_code"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          dssConnectionSettingInput.dss_chain_store_code = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS URL -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_dss_api_base_url }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="dss_api_base_url"
                    :label="wordList.lbl_dss_api_base_url"
                    rules="required"
                  >
                    <v-text-field
                      :model-value="field.value ?? dssConnectionSettingInput.dss_api_base_url"
                      :placeholder="wordList.plc_dss_api_base_url"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          dssConnectionSettingInput.dss_api_base_url = val;
                        }
                      "
                      @blur="
                        () => {
                          field.onBlur();
                          onBlurDssUrl();
                        }
                      "
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS アクセスキー -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_access_key }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="access_key"
                    :label="wordList.lbl_access_key"
                    rules="required|max:24|regex:^[0-9a-zA-Z]+$"
                  >
                    <v-text-field
                      :model-value="field.value ?? dssConnectionSettingInput.access_key"
                      :placeholder="wordList.plc_access_key"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          dssConnectionSettingInput.access_key = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- DSS シークレットキー -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_secret_key }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <Field
                    v-slot="{ field, errors }"
                    name="secret_key"
                    :label="wordList.lbl_secret_key"
                    rules="required|max:24|regex:^[0-9a-zA-Z]+$"
                  >
                    <v-text-field
                      :model-value="field.value ?? dssConnectionSettingInput.secret_key"
                      :placeholder="wordList.plc_secret_key"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          dssConnectionSettingInput.secret_key = val;
                        }
                      "
                      @blur="field.onBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-center py-10">
            <v-btn
              variant="flat"
              color="primary"
              class="px-16 chain-register-submit"
              :disabled="invalid || isRequiredFieldsMissing"
              @click="() => onClickOpenConfirmDialog(validate)"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <span>{{ wordList.btn_regist_confirm }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </Form>
    </v-card>
    <!-- チェーン登録確認ダイアログ { -->
    <v-card v-if="displayConfirmDialog" :flat="true">
      <v-card :flat="true">
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_chain_regist_confirm }}
        </v-card-title>
        <v-card-text style="min-height: 500px" class="pt-5 confirm-display-text">
          <!-- チェーンコード -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_chain_code }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ chainCreateInput.chain_code }}</v-col>
          </v-row>
          <!-- チェーン名 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_chain_name }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ chainCreateInput.name }}</v-col>
          </v-row>
          <!-- ハウスカード登録 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_house_card_display }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ houseCardDisplayRadio["name"] }}</v-col>
          </v-row>
          <!-- ハウスカード必須 -->
          <v-row v-if="houseCardDisplayRadio['id'] == 1" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_house_card_required }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ houseCardRequiredRadio["name"] }}</v-col>
          </v-row>
          <!-- ハウスカード桁数 -->
          <v-row v-if="houseCardDisplayRadio['id'] == 1" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_house_card_digit }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ chainCreateInput.house_card_digit }}</v-col>
          </v-row>
          <!-- ハウスカード書式 -->
          <v-row v-if="houseCardDisplayRadio['id'] == 1" class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_house_card_format }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ chainCreateInput.house_card_format }}</v-col>
          </v-row>
          <!-- オペレーターのメールアドレス -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_operator_column_email }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ operatorColumnEmailRadio["name"] }}</v-col>
          </v-row>
          <!-- DSS接続名 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_dss_connection_name }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              dssConnectionSettingInput.connection_name
            }}</v-col>
          </v-row>
          <!-- DSSチェーンストアコード -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_dss_chain_store_code }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              dssConnectionSettingInput.dss_chain_store_code
            }}</v-col>
          </v-row>
          <!-- DSS URL -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_dss_api_base_url }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
              dssConnectionSettingInput.dss_api_base_url
            }}</v-col>
          </v-row>
          <!-- DSSアクセスキー -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_access_key }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ dssConnectionSettingInput.access_key }}</v-col>
          </v-row>
          <!-- DSSシークレットキー -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_secret_key }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{ dssConnectionSettingInput.secret_key }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="return"
            class="px-16"
            @click="onClickConfirmCancel"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ wordList.btn_return }}</v-btn
          >
          <v-btn
            variant="flat"
            color="primary"
            class="px-16"
            @click="onClickConfirmEntry"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <span>{{ wordList.btn_regist_complete }}</span>
          </v-btn>
        </v-card-actions>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-card>
    <!-- } チェーン登録確認ダイアログ -->
    <!-- チェーン登録完了ダイアログ { -->
    <v-card v-if="displayCompletedDialog" :flat="true">
      <v-card
        v-if="createChainMutation !== null && createChainMutation !== undefined"
        :flat="true"
      >
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_chain_regist_complete }}
        </v-card-title>
        <v-card-text style="min-height: 500px">
          <v-row class="pt-5">
            <v-col class="font-weight-black">
              {{ wordList.lbl_chain_regist_complete_msg }}
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <!-- チェーンコード -->
            <v-col cols="3" class="font-weight-black">
              {{ wordList.lbl_chain_code }}
            </v-col>
            <v-col cols="9">{{
              createChainMutation.createChain.chain_code
            }}</v-col>
          </v-row>
          <v-row class="ml-5">
            <v-col cols="3" class="font-weight-black">
              {{ wordList.lbl_chain_name }}
            </v-col>
            <v-col cols="9">{{ createChainMutation.createChain.name }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            class="px-16"
            @click="onClickCompletedGoStart"
          >
            {{ wordList.btn_chain_regist_return }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } チェーン登録完了ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max, regex, length, alpha_dash, numeric } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";

import { useChainRegisterUiState } from "./composables/useChainRegisterUiState";
import { useChainRegisterApi } from "./composables/useChainRegisterApi";
import { useChainRegisterForm } from "./composables/useChainRegisterForm";
import { useChainRegisterInit } from "./composables/useChainRegisterInit";
import { useChainRegisterActions } from "./composables/useChainRegisterActions";

// --- VeeValidate のルール設定 ---
defineRule("required", required);
defineRule("max", max);
defineRule("regex", regex);
defineRule("length", length);
defineRule("alpha_dash", alpha_dash);
defineRule("numeric", numeric);
configure({
  generateMessage: localize({ ja }),
});
setLocale('ja');

////////////////////////////////////////////////////////////////////////////////
// 共有リアクティブ状態（Form・Init 両方から参照されるため、コンポーネントレベルで生成）
////////////////////////////////////////////////////////////////////////////////
const wordList = ref<Record<string, string>>({});
const chainListItems = ref<
  ({ __typename?: "Chain"; chain_code: string; name: string } | null | undefined)[] | null
>(null);

////////////////////////////////////////////////////////////////////////////////
// Composables
////////////////////////////////////////////////////////////////////////////////

const {
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
  dssConnectionSettingMutation,
  createChainMutation,
} = useChainRegisterUiState();

const {
  getWordListData,
  getChainListData,
  getChainCountOverCustomerData,
  createDssConnectionSettingData,
  createChainData,
} = useChainRegisterApi({ errdialog, errMessage });

const {
  chainCreateInput,
  dssConnectionSettingInput,
  houseCardDisplayRadio,
  houseCardRequiredRadio,
  operatorColumnEmailRadio,
  houseCardDisabled,
  houseCardDisplayRadioItems,
  houseCardRequiredRadioItems,
  operatorColumnEmailRadioItems,
  formInitialValues,
  isRequiredFieldsMissing,
  onClickHouseCard,
  onBlurChainCd,
  onBlurChainName,
  onBlurDssUrl,
  resetForm,
} = useChainRegisterForm({
  errdialog,
  errMessage,
  overlay,
  wordList,
  chainListItems,
  getChainCountOverCustomerData,
});

const {
  isWordListReady,
  runInitialLoad,
} = useChainRegisterInit({
  errdialog,
  errMessage,
  overlay,
  wordList,
  chainListItems,
  getWordListData,
  getChainListData,
});

const {
  onClickOpenConfirmDialog,
  onClickConfirmCancel,
  onClickConfirmEntry,
  onClickCompletedGoStart,
} = useChainRegisterActions({
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
  dssConnectionSettingMutation,
  createChainMutation,
  chainCreateInput,
  dssConnectionSettingInput,
  houseCardDisplayRadio,
  houseCardRequiredRadio,
  operatorColumnEmailRadio,
  createDssConnectionSettingData,
  createChainData,
  resetForm,
});

////////////////////////////////////////////////////////////////////////////////
// 初期画面
////////////////////////////////////////////////////////////////////////////////
onMounted(async (): Promise<void> => {
  await runInitialLoad();
});
</script>
<style scoped>
.chain-register-form:has(.v-messages__message) .chain-register-submit {
  opacity: 0.5;
  filter: grayscale(0.2);
  cursor: not-allowed;
}
</style>
